/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { Button, ButtonGroup } from 'reactstrap'

// REDUX BITS
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as objectiveActions from '../../../actions/objectiveActions'

import GoalRow from './GoalRow'
import Placeholder from '../../common/Placeholder'
import './Goals.scss'

class GoalList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      objectives: [],
      loader: false,
      selectedGoalType: 'current',
    }
  }

  componentDidMount() {
    this.props.ranks.map((rank) => {
      if (rank.name === this.props.currentRank?.name) {
        this.props.getObjectivesFromRank(rank.id, this.props.user.id)
      }
    })
  }

  goalTypeSwitcher = (type) => {
    this.setState({
      selectedGoalType: type,
    })
  }

  goalSwitcher = () => {
    const { t } = this.props
    return (
      <ButtonGroup className='goal-switch-button-wrapper'>
        <Button
          className={`goal-switch-button ${
            this.state.selectedGoalType === 'current'
              ? 'active-goal-button'
              : ''
          }`}
          onClick={() => this.goalTypeSwitcher('current')}
        >
          {t('profile.common.open')}
        </Button>
        <Button
          className={`goal-switch-button ${
            this.state.selectedGoalType === 'complete'
              ? 'active-goal-button'
              : ''
          }`}
          onClick={() => this.goalTypeSwitcher('complete')}
        >
          {t('profile.common.completed')}
        </Button>
      </ButtonGroup>
    )
  }

  calculateCurrentObjectives = () => {
    const current = []
    this.props.objectives.map((objective) => {
      if (!objective.completed_date) {
        current.push(objective)
      }
    })

    return current.length
  }

  calculateCompleteObjectives = () => {
    const completed = []
    this.props.objectives.map((objective) => {
      if (objective.completed_date) {
        completed.push(objective)
      }
    })

    return completed.length
  }

  displayPrivateGoals = (type) => (
    <GoalRow
      user={this.props.user}
      goals={this.props.goals}
      isMobile={this.props.isMobile}
      customGoalPage={this.props.customGoalPage}
      isPrivateGoals={true}
      selectedGoalType={this.state.selectedGoalType}
      goalTypeSwitcher={this.goalTypeSwitcher}
      type={type}
    />
  )

  displayGoals = (type) => { // eslint-disable-line arrow-body-style
    return this.props.ranks.map((rank) => {
      if (type === 'complete' && rank.progress_percentage > 0) {
        return (
          <GoalRow
            user={this.props.user}
            current_user={this.props.current_user}
            rank={rank}
            key={rank.id}
            type={type}
            currentRank={this.props.currentRank}
            rowLoader={this.props.rowLoader}
            gotInitialGoals={this.props.gotInitialGoals}
            toggleRowLoader={this.props.toggleRowLoader}
            toggleIncompleteModal={this.props.toggleIncompleteModal}
            toggleDropdown={this.props.toggleDropdown}
            collapse={this.props.collapse}
            getObjectivesFromRankRow={this.props.getObjectivesFromRankRow}
            getCurrentObjective={this.props.getCurrentObjective}
            objectiveActivities={this.props.objectiveActivities}
            isPrivateGoals={false}
          />
        )
      } else if (type === 'current') {
        return (
          <GoalRow
            user={this.props.user}
            current_user={this.props.current_user}
            rank={rank}
            key={rank.id}
            type={type}
            currentRank={this.props.currentRank}
            rowLoader={this.props.rowLoader}
            rankUp={this.props.rankUp}
            gotInitialGoals={this.props.gotInitialGoals}
            toggleRowLoader={this.props.toggleRowLoader}
            toggleCompleteModal={this.props.toggleCompleteModal}
            toggleDropdown={this.props.toggleDropdown}
            collapse={this.props.collapse}
            getObjectivesFromRankRow={this.props.getObjectivesFromRankRow}
            getCurrentObjective={this.props.getCurrentObjective}
            objectiveActivities={this.props.objectiveActivities}
            isPrivateGoals={false}
          />
        )
      }
    })
  }

  render() {
    const { t } = this.props
    return (
      <div className='container private-goal-mobile'>
        {this.props.isPrivateGoals ? (
          this.props.gotGoals &&
          this.props.goals &&
          this.props.goals.length > 0 ? (
              this.state.selectedGoalType === 'current' ? (
                <div className='mb-5'>{this.displayPrivateGoals('current')}</div>
              ) : (
                <div className='mb-5'>{this.displayPrivateGoals('complete')}</div>
              )
            ) : (
              <Placeholder
                title={t('profile.goals.list.noPrivateGoalsTitle')}
                icon={'fa-trophy'}
                subtext1={t('profile.goals.list.noPrivateGoalsSubtext')}
                subtext2={
                  this.props.current_user.type === 'Coach'
                    ? t('profile.goals.list.noPrivateGoalsCoachInstruction')
                    : t('profile.goals.list.noPrivateGoalsStudentInstruction')
                }
                buttonText={
                  this.props.current_user.type === 'Coach'
                    ? t('profile.common.addPrivateGoal')
                    : null
                }
                buttonIcon={'fa-plus'}
                handleClick={() => this.props.toggleModal('goals')}
              />
            )
        ) : (
          <div className='custom-goal-container'>
            <div className='custom-goal-header curriculum-header'>
              <button
                className='mb-3 back-curriculms-btn'
                onClick={this.props.decrementPage}
              >
                <i
                  className='fa fa-arrow-left back-curriculms-icon'
                  aria-hidden='true'
                />
              </button>
              <div className='custom-goal-header-info-wrapper'>
                <div className='custom-goal-header-wrapper'>
                  <div className='custom-goal-header-title-wrapper'>
                    <h4 className='custom-goal-header-title op36-curriculum-title'>
                      {t('profile.common.operation36Curriculum')}
                    </h4>
                  </div>
                  <div className='row current-rank-row'>
                    <p className='current-rank'>{this.props.currentRank.name}</p>
                  </div>
                  <div className='row custom-goal-text-row'>
                    <div className='col-md-6 custom-goal-text-wrapper pr-0'>
                      <p className='custom-goal-text'>{t('profile.goals.list.openLabel')}</p>{' '}
                      <span className='custom-goal-text-aside'>
                        {this.props.loader
                          ? t('profile.goals.list.loadingCount')
                          : this.calculateCurrentObjectives()}
                      </span>
                    </div>
                    <div className='col-md-6 custom-goal-text-wrapper pr-0'>
                      <p className='custom-goal-text'>{t('profile.goals.list.completedLabel')}</p>{' '}
                      <span className='custom-goal-text-aside an'>
                        {this.props.loader
                          ? t('profile.goals.list.loadingCount')
                          : this.calculateCompleteObjectives()}
                      </span>
                    </div>
                  </div>
                </div>
                <div className='custom-goal-header-info'>
                  <div className='progress'>
                    <div
                      className='progress-bar'
                      role='progressbar'
                      style={{
                        width: `${
                          !this.props.percentage ? '0' : this.props.percentage
                        }%`,
                        backgroundColor: '#ff6633',
                      }}
                      aria-valuenow={
                        !this.props.percentage ? 0 : this.props.percentage
                      }
                      aria-valuemin='0'
                      aria-valuemax='100'
                    >
                      {!this.props.percentage
                        ? ''
                        : `${this.props.percentage}%`}
                    </div>
                  </div>
                  <div className='private-goal-toggle custom-goal-switcher'>
                    {this.goalSwitcher()}
                  </div>
                </div>
              </div>
            </div>
            {this.state.selectedGoalType === 'current' ? (
              <div className='mt-5'>{this.displayGoals('current')}</div>
            ) : (
              <div className='mt-5'>{this.displayGoals('complete')}</div>
            )}
          </div>
        )}
      </div>
    )
  }
}

GoalList.propTypes = {
  currentRank: PropTypes.shape({
    name: PropTypes.string,
  }),
  ranks: PropTypes.array,
}

function mapStateToProps(state, ownProps) {
  return {
    objectives: state.objectives[ownProps.currentRank?.order],
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(objectiveActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(GoalList))
